import cookies from "js-cookie";
import getFeatureVariables from "@template/helpers/getFeatureVariables";
import setCookieFromFeatureVariables from "./setCookieFromFeatureVariables";
import { COOKIE_NAME, FEATURE_NAME } from "./constants";

const isEmptyObject = val =>
  Object.keys(val).length === 0 && val.constructor === Object;

const setupCookie = async () => {
  const variables = await getFeatureVariables(FEATURE_NAME);

  if (!variables || isEmptyObject(variables) || variables.queryParams === "") {
    cookies.remove(COOKIE_NAME);

    return;
  }

  setCookieFromFeatureVariables(variables);
};

export default setupCookie;
